import CourseRoutes from './routes'
export default CourseRoutes
